export default "__VITE_ASSET__13IluW$V__"